import * as OSS from "ali-oss";
import util from "./util";
import file_util from "./file.operator";

const ACCESSKEY = "LTAI4G7Jg2VRgqE6yMNurHz6";
const ACCESSSECRET = "tpqmDamOKhMKzKEWmMzXY3HfJFa0Qo";

const oss_url = "https://zayn1.oss-cn-beijing.aliyuncs.com/";

export default function (file, callback, cancelback) {
    const client = new OSS({
        accessKeyId: ACCESSKEY,
        accessKeySecret: ACCESSSECRET,
        bucket: "zayn1",
        region: "oss-cn-beijing",
        secure: true,
    });

    var file_type = file_util.getFileType(file);
    var file_name = util.getNonDuplicateID() + "." + file_type;
    var max_size = 100 * 1024 * 1024;
    if (file.size > max_size) {
        if (cancelback) {
            cancelback("视频不能超过100M");
        }
        return;
    }
    console.log("*******");
    console.log(file.size);
    var folder_name = "medtronic/video/";
    client.put(folder_name + file_name, file).then((res) => {
        if (callback) {
            callback(oss_url + folder_name + file_name);
        }
    });
}



// WEBPACK FOOTER //
// ./src/leo.wang.util/ali-oss.js